import api from './api';
import api2 from './api2';

export function getCorretajePagos(idAsesor,tipoDocumento,identificacion) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/corretaje/getSettlement/idAsesor/${idAsesor}/${tipoDocumento}/${identificacion}`)
}

export function postEnviarPlanilla(identificacion,data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/corretaje/enviar/${identificacion}`,data)
}

export function getConsultarProceso(identificacion) {
  return api2.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/corretaje/consultarProceso/${identificacion}`)
}

export function postAceptarSettlement(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/corretaje/acceptanceSettlement`,data)
}